module.exports = __webpack_public_path__ + "static/media/arr_next.fae4ea7e.svg";